import React from 'react';
import PropTypes from 'prop-types';
import PriceDisplay from '../PriceDisplay/PriceDisplay';
import StarRating from '../StarRating/StarRating';
import ProductBadge from '../ProductBadge/ProductBadge';
import isEnterOrSpace from '../../helpers/isEnterOrSpace';
import normalizeAttributeGroups from '../../helpers/normalizeAttributeGroups';
import AddOnCallout from '../AddOnCallout/AddOnCallout';


const ProductCard = ({
  analytics,
  product,
  product: {
    images,
    productName,
    promotions,
    ratingSummary,
  },
  list,
}) => {
  const attributes = normalizeAttributeGroups(product);

  return (
    <div className="product-card">
      <div
        className="product-card__card-wrap"
        onClick={() => analytics.productClick(product, list)}
        onKeyPress={event => isEnterOrSpace(event) && analytics.productClick(product, list)}
        role="link"
        tabIndex={0}
      >
        <div className="product-card__image-wrap">
          <ProductBadge className="product-card__badge" attributes={attributes} promotions={promotions} />
          <img className="product-card__image" src={images.productTile[0].url} alt="" />
        </div>
        <div className="product-card__details-wrap">
          <div className="product-card__name">{productName}</div>
          <div className="product-card__rating"><StarRating {...ratingSummary} /></div>
          <PriceDisplay {...product} />
        </div>
        {attributes.addOns && attributes.addOns.map(addOn => (
          <AddOnCallout key={addOn.id} addOn={addOn} />
        ))}
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  product: PropTypes.shape({
    addOns: PropTypes.arrayOf(PropTypes.shape({
      values: PropTypes.shape({
        maxAddOnPrice: PropTypes.number,
        minAddOnPrice: PropTypes.number,
      }),
      content: PropTypes.shape({
        modalBody: PropTypes.string,
        title: PropTypes.string,
        subtitleModalTrigger: PropTypes.string,
      }),
      type: PropTypes.string,
    })),
    images: PropTypes.shape({
      productTile: PropTypes.arrayOf(PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
      })),
    }).isRequired,
    productName: PropTypes.string.isRequired,
    price: PropTypes.shape({}).isRequired,
    rebates: PropTypes.shape({
      min: PropTypes.shape({
        value: PropTypes.number.isRequired,
        formatted: PropTypes.string,
      }),
      max: PropTypes.shape({
        value: PropTypes.number.isRequired,
        formatted: PropTypes.string,
      }),
      label: PropTypes.string,
      tooltip: PropTypes.string,
    }),
    rebatePrice: PropTypes.shape({}),
    productUrl: PropTypes.string.isRequired,
    promotions: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  analytics: PropTypes.shape({
    productClick: PropTypes.func,
  }).isRequired,
  list: PropTypes.string.isRequired,
};

export default ProductCard;
